<template>
  <aside class="flex h-full w-64 flex-col border-r border-theme-border bg-theme-surface">
    <admin-cauldron-rail @navigate="emit('navigate')" />
    <div class="min-h-0 flex-1">
      <Transition name="nav-fade" mode="out-in">
        <admin-cauldron-sidebar :key="activeCauldron?.id || 'home'" :cauldron="activeCauldron" @navigate="emit('navigate')" />
      </Transition>
    </div>

    <div class="border-t border-theme-border px-3 py-3">
      <app-button
        v-if="canSubmitFeedback"
        class="mb-2"
        :label="t('feedback.menu')"
        :icon="mdiMessageAlertOutline"
        variant="ghost"
        tone="neutral"
        justify="start"
        block
        data-test="admin-feedback-open"
        @click="openFeedback()"
      />
      <div class="mb-2 min-w-0 px-2 text-xs text-theme-text-secondary">
        <div class="truncate font-medium text-theme-text">
          {{ userLabel || t('admin.shell.user_fallback') }}
        </div>
        <div class="truncate">{{ userStore.email }}</div>
      </div>
      <app-button
        :label="t('admin.shell.sign_out')"
        :icon="mdiLogout"
        variant="ghost"
        tone="neutral"
        justify="start"
        block
        @click="logout"
      />
    </div>
  </aside>
</template>

<script setup>
  /* eslint-disable no-undef */
  import AdminCauldronRail from '@/admin/components/navigation/AdminCauldronRail.vue';
  import AdminCauldronSidebar from '@/admin/components/navigation/AdminCauldronSidebar.vue';
  import { useAdminActiveCauldron } from '@/admin/composables/useAdminActiveCauldron';
  import AppButton from '@/components/ui/buttons/AppButton.vue';
  import { useAuthStore } from '@/stores/useAuthStore';
  import { useUserStore } from '@/stores/useUserStore';
  import { openFeedback } from '@/composables/useFeedback';
  import { useFeedbackAccess } from '@/features/feedback/composables/useFeedbackAccess';
  import { mdiLogout, mdiMessageAlertOutline } from '@mdi/js';
  import { computed } from 'vue';
  import { useI18n } from 'vue-i18n';
  import { useRouter } from 'vue-router';

  const emit = defineEmits(['navigate']);

  const { t } = useI18n();

  const router = useRouter();
  const authStore = useAuthStore();
  const userStore = useUserStore();
  const { activeCauldron } = useAdminActiveCauldron();
  // Same allowlist as the portal: the button only shows for accounts that may submit.
  const { canSubmit: canSubmitFeedback } = useFeedbackAccess();

  const userLabel = computed(() => {
    const name = [userStore.firstname, userStore.lastname].filter(Boolean).join(' ');
    return name || userStore.email || '';
  });

  async function logout() {
    await authStore.logoutUser();
    router.push({ name: 'admin-login' });
  }
</script>
